export const Items = [
  {
    id: 0,
    name: 'Simple',
    description: 'Compra 7 tanques',
    nameButton: 'COMPRAR',
    packageType: 'SIMPLE',
    price: '833',
    amount: '7',
    pack_id: '1',
    amountDefault: '7',
    priceDefault: '833',
  },
  {
    id: 1,
    name: 'Inter',
    description: 'Compra 15 tanques',
    nameButton: 'COMPRAR',
    packageType: 'INTER',
    price: '1635',
    amount: '15',
    pack_id: '3',
    amountDefault: '15',
    priceDefault: '1635',
  },
  {
    id: 2,
    name: 'Pro',
    description: 'Compra 30 tanques',
    nameButton: 'COMPRAR',
    packageType: 'PRO',
    price: '2970',
    amount: '30',
    pack_id: '5',
    amountDefault: '30',
    priceDefault: '2970',
  },
];
